import React from 'react';
import {Home} from '../../containers/home';

export default Home;